import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
const zendeskAuthenticateUserSchema = z.object({
    accessToken: z.string(),
});
export class ZendeskAuthenticateUserResponseDto extends createZodDto(zendeskAuthenticateUserSchema) {
}
